import { Component, Input, OnInit } from '@angular/core';
import * as ChartDataLabels from 'chartjs-plugin-datalabels';
import { DashboardCustomerKPIService, ValueType } from '../../../services';

@Component({
  selector: 'dashboard-customer-kpi-display',
  templateUrl: './dashboard-customer-kpi-display.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPIDisplayComponent implements OnInit {
  constructor(public dashboardKPIService: DashboardCustomerKPIService) {}

  @Input() metrics: any[];
  public ValueType = ValueType;

  protected plugin: any;

  async ngOnInit() {
    this.plugin = ChartDataLabels;
  }
}
